type Relationships = {
  [modelName: string]: {
    data: {
      id: string;
      type: string;
    };
  };
};

export type DeliveryAddressResponse = {
  data: {
    data: {
      attributes: {
        city: string /* "Brooklyn" */;
        is_doorman: boolean;
        is_valid?: boolean;
        notes?: string /* "GraphQL is the future" */;
        state: string /* "NY" */;
        street: string /* "42 West St." */;
        street_two?: string /* null */;
        updated_at?: Date;
        validation_source?: string /* "smarty_streets" */;
        zip_code: string /* "11222" */;
      };
      id: string /* "None" */;
      relationships: Relationships /* {} */;
      type: 'DeliveryAddress';
    };
  };
  status: number /* 201 */;
  statusText: string /* "OK" */;
};

export async function validateDeliveryAddress(client, { formValues, accountId }): Promise<DeliveryAddressResponse> {
  const { zip_code, street_two, street, is_doorman, is_valid, notes } = formValues;
  return await client.validateAddress({
    data: {
      type: 'DeliveryAddress',
      attributes: {
        zip_code,
        ...(street_two?.length > 0 && { street_two }), // only add street two property if it has a value
        ...((is_valid === true || is_valid === false) && { is_valid }), // only add street two property if it has a value
        street,
        is_doorman,
        ...(notes && { notes }),
      },
      relationships: {
        account: {
          data: {
            type: 'Account',
            id: accountId,
          },
        },
      },
    },
  });
}

export async function createDeliveryAddress(client, { accountId, attributes = {} }) {
  return await client.deliveryAddress.create({
    data: {
      attributes,
      type: 'DeliveryAddress',
      relationships: {
        account: {
          data: {
            type: 'Account',
            id: accountId,
          },
        },
      },
    },
  });
}

export async function updateDeliveryAddress(client, addressId, { accountId, attributes = {} }) {
  return await client.deliveryAddress.patch(addressId, {
    data: {
      id: addressId,
      attributes,
      type: 'DeliveryAddress',
      relationships: {
        account: {
          data: {
            type: 'Account',
            id: accountId,
          },
        },
      },
    },
  });
}
